import { trackAuthenticatedUsers } from "./authenticated"

export const global = {
  trackAuthenticatedUsers,
}
